import { render, staticRenderFns } from "./Footerbar.vue?vue&type=template&id=7b7bed28&scoped=true"
import script from "./Footerbar.vue?vue&type=script&lang=js"
export * from "./Footerbar.vue?vue&type=script&lang=js"
import style0 from "./Footerbar.vue?vue&type=style&index=0&id=7b7bed28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7bed28",
  null
  
)

export default component.exports